import { nanoid } from 'nanoid';

// One result shown once in one search context gets one impression id, reported once. Both
// halves have to outlive the result rows: the list remounts whenever the same search runs
// again — results are cleared, then refilled — and a remounted row would otherwise mint a
// fresh id, breaking the click's join back to its impression, or re-report the id it was
// already sent under. Reset when the context changes.
export class SearchImpressionRegistry {
  private impressionIds = new Map<string, string>();
  private reported = new Set<string>();

  getImpressionId(itemId?: string, resultType?: string, contextId?: string): string | undefined {
    if (!contextId || !itemId) {
      return undefined;
    }

    const key = `${contextId}-${itemId}-${resultType}`;

    if (!this.impressionIds.has(key)) {
      this.impressionIds.set(key, nanoid());
    }

    return this.impressionIds.get(key);
  }

  wasReported(impressionId?: string): boolean {
    return !!impressionId && this.reported.has(impressionId);
  }

  markReported(impressionId?: string): void {
    if (impressionId) {
      this.reported.add(impressionId);
    }
  }

  reset(): void {
    this.impressionIds.clear();
    this.reported.clear();
  }
}
